import { useEffect, useState } from 'react'
import { FileSpreadsheet } from 'lucide-react'
import Button from '../../components/Button'
import ExcelUploadFields from '../../components/ExcelUploadFields'
import { FormBody } from '../../components/Form'
import Modal from '../../components/Modal'
import { strings as S } from './strings'
import './modals.css'

/** Matches the spreadsheet and CSV formats accepted by the import endpoint. */
const ACCEPT =
  '.xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv'

const COLUMNS = [
  { name: 'Username', required: true },
  { name: 'Group', required: true },
]

/** `#bulk_modal` — updates employee departments from a spreadsheet. */
export default function GroupBulkModal({ open, onClose, onSubmit }) {
  const [file, setFile] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!open) return
    setFile(null)
    setError('')
  }, [open])

  const submit = (event) => {
    event.preventDefault()
    if (!file) {
      setError(S.bulkModal.missingFile)
      return
    }
    /* `file`, not `excelFile`. The page destructures `{ file }`, so the old key
       arrived as undefined and `bulkAssignUsers` returned its no-file guard —
       which has no message, so the screen showed the generic "could not complete
       the operation" and the upload never left the browser. `excelFile` is the
       name of the multipart FIELD, which is the service's business. */
    onSubmit({ file })
  }

  return (
    <Modal
      open={open}
      title={S.bulkModal.title}
      icon={FileSpreadsheet}
      hint={S.bulkModal.hint}
      onClose={onClose}
      footer={
        <>
          <Button type="submit" form="group-bulk-form">
            {S.bulkModal.submit}
          </Button>
          <Button variant="ghost" onClick={onClose}>
            {S.close}
          </Button>
        </>
      }
    >
      <form id="group-bulk-form" onSubmit={submit} noValidate>
        <FormBody>
          <ExcelUploadFields
            id="group-bulk-file"
            accept={ACCEPT}
            columns={COLUMNS}
            templateHref="/root/ExcelTemplates/Groups_Users_Departments.xlsx"
            error={error}
            strings={{ ...S.excel, intro: S.excel.introXlsxOnly }}
            onChange={(selected) => {
              setFile(selected)
              setError('')
            }}
          />
        </FormBody>
      </form>
    </Modal>
  )
}
